// Estimated 1RM (Epley) and per-set scoring used by the progression engine's
// stall detection and the strength-trend chart. Pure functions.

import type { Exercise, SetLog } from './types';
import { absoluteLoadKg } from './weight';

// Epley: 1RM = w * (1 + reps/30). Reasonable for the 1-15 rep range we train in.
export function epley(weightKg: number, reps: number): number {
  if (reps <= 1) return weightKg;
  return weightKg * (1 + reps / 30);
}

export function workingSets(sets: SetLog[]): SetLog[] {
  return sets.filter((s) => !s.isWarmup);
}

// A single comparable number for a session's effort on one exercise. Uses the
// best working set's estimated 1RM (absolute load for bodyweight movements). For
// pure-reps progress on light bodyweight work it still rises as reps climb.
export function sessionScore(
  sets: SetLog[],
  ex: Pick<Exercise, 'bodyweight'>,
  bodyweightKg: number | null,
): number {
  const ws = workingSets(sets);
  if (ws.length === 0) return 0;
  let best = 0;
  for (const s of ws) {
    const load = absoluteLoadKg(s.weightKg, ex, bodyweightKg);
    best = Math.max(best, epley(load, s.reps));
  }
  return best;
}
